/**
 * Studio PR 工作台：`PrStudioService.prPayloadPreset` → `prStudioPayloadPresets` / `_utils`；
 * 表格后端下载：`PrDownloadButton`。
 * KPI/趋势/列表：`PrSummaryCards`、`PrTrendSection`、`PrMediaTable`。
 */

export const PR_WORKSPACE_PAGE_CONFIG = {
  "name": "CommonLogWrap",
  "config": {
    "logConfig": {
      "menuId": "",
      "pageId": "102100",
      "pageName": "studio PR workspace",
      "extInfo": "PR-studio-pr-workspace",
      "pagePath": "/pr"
    }
  },
  "children": [{
    "name": "PrStudioMonthFilter",
    "props": {
      "timeZone": 0
    },
    "children": [{
      "name": "PrNoticeMarquee",
      "props": {
        "textEn": "MVP Version — This page reflects all data currently available from LevelUp's API. However, some figures may not fully align with LevelUp's own Press Report due to ongoing API-level limitations. Full data coverage will be available in a future update.",
        "textZh": "MVP 版本 — 本页面已展示 LevelUp API 目前所能提供的全部数据，但受限于 LevelUp 数据接口存在部分缺口，当前数据与 LevelUp 前端可能存在出入，完整数据将于后续迭代中补齐。"
      }
    }, {
      "name": "PrStudioService",
      "className": "",
      "type": "view",
      "style": {},
      "data": {},
      "props": {
        "api": "/api/v2/dashboard/studio/pr/overview/kpi",
        "dataKey": "prSummaryCards",
        "filterLoading": false,
        "trackData": ["frameCode", "prHubGameCode", "prGamesChannels", "studioData"],
        "prPayloadPreset": "pr:studio"
      },
      "children": [{
        "name": "PrSummaryCards",
        "props": {
          "dataKey": "prSummaryCards",
          "summaryMetrics": [{
            "metricKey": "media",
            "valueKey": "media_count",
            "subTemplateEn": "in {{country_count}} countries",
            "subTemplateCn": "覆盖{{country_count}}个国家",
            "enName": "Media",
            "cnName": "媒体数",
            "tooltipEn": "Number of unique media sources mentioning the game; filtered by press creators from creators, then filtered by press creators from posts.",
            "tooltipCn": "提及该游戏的去重媒体来源数量；从 creators 筛选 press creator，再从 posts 过滤 press creator",
            "formatRule": "thousandsInit"
          }, {
            "metricKey": "articles",
            "valueKey": "articles_count",
            "subTemplateEn": "{{total_comments|dataFormat;thousandsInit}} comments",
            "subTemplateCn": "{{total_comments|dataFormat;thousandsInit}} 条评论",
            "enName": "Articles",
            "cnName": "独立站文章数",
            "tooltipEn": "Number of articles on independent media websites.",
            "tooltipCn": "独立媒体网站的文章数量",
            "formatRule": "thousandsInit"
          }, {
            "metricKey": "posts",
            "valueKey": "posts_count",
            "subTemplateEn": "{{total_interactions|dataFormat;bmk}} interactions",
            "subTemplateCn": "{{total_interactions|dataFormat;bmk}} 互动量",
            "enName": "Posts",
            "cnName": "社媒主贴数",
            "tooltipEn": "Number of posts on social media platforms.",
            "tooltipCn": "社媒平台上主贴的数量",
            "formatRule": "thousandsInit"
          }, {
            "metricKey": "est_impressions",
            "valueKey": "total_est_impressions",
            "enName": "Est. Impressions",
            "cnName": "预估曝光量",
            "tooltipEn": "Same as the existing database field \"Potential Impressions\".",
            "tooltipCn": "同 DB 现有「Potential Impressions」字段数据",
            "formatRule": "bmk0"
          }]
        }
      }]
    }, {
      "name": "PrWorkspaceTabs",
      "props": {
        "tabList": [{
          "id": "overview",
          "tabName": "Overview",
          "tabNameCN": "概览"
        }, {
          "id": "media",
          "tabName": "Media",
          "tabNameCN": "媒体数"
        }, {
          "id": "regions",
          "tabName": "Regions",
          "tabNameCN": "地区"
        }, {
          "id": "articles",
          "tabName": "Articles",
          "tabNameCN": "独立站文章数"
        }, {
          "id": "posts",
          "tabName": "Posts",
          "tabNameCN": "社媒主贴数"
        }, {
          "id": "videos",
          "tabName": "Videos",
          "tabNameCN": "视频"
        }, {
          "id": "streams",
          "tabName": "Streams",
          "tabNameCN": "直播"
        }]
      },
      "children": [
        {
          "name": "PrTabPanel",
          "props": {
            "tabId": "overview"
          },
          "children": [{
            "name": "PrAiSummary",
            "className": "pr-gpt-summary",
            "props": {
              "id": "Player Sentiment Summary",
              "index": 0,
              "isOpinionsUrl": true,
              "gptTitleEn": "AI Summary",
              "gptTitleCn": "AI 总结",
              "titleConfig": {
                "rightSlot": {
                  "name": "EditGpt"
                }
              }
            }
          }, {
            "name": "PrStudioService",
            "className": "",
            "type": "view",
            "style": {},
            "data": {},
            "props": {
              "api": "/api/v2/dashboard/studio/pr/overview/trend",
              "dataKey": "prSentimentTrend",
              "filterLoading": false,
              "trackData": ["frameCode", "prHubGameCode", "prGamesChannels", "studioData", "isDateChanged"],
              "prPayloadPreset": "pr:trend"
            },
            "children": [{
              "name": "PrStudioService",
              "className": "",
              "type": "view",
              "style": {},
              "data": {},
              "props": {
                "api": "/api/v1/opinion_pc/overview/mentions_stats_timeline",
                "dataKey": "prEventTimeline",
                "filterLoading": false,
                "trackData": ["frameCode", "prHubGameCode", "studioData"],
                "prPayloadPreset": "pr:eventTimeline"
              },
              "children": [{
                "name": "PrTrendSection",
                "props": {
                  "dataKey": "prSentimentTrend",
                  "eventDataKey": "prEventTimeline",
                  "titleEn": "Evolution Chart",
                  "titleCn": "趋势图",
                  "metricNameEn": "Articles",
                  "metricNameCn": "独立站文章数",
                  "chartHeight": 340,
                  "formatRule": "thousandsInit",
                  "yaxFormatRule": "intBmk00"
                }
              }]
            }]
          }]
        }, {
          "name": "PrTabPanel",
          "props": {
            "tabId": "media"
          },
          "children": [{
            "name": "PrStudioService",
            "className": "",
            "type": "view",
            "style": {},
            "data": {
              "extraParams": {
                "page": 1,
                "page_size": 10,
                "sort_by": "publications",
                "desc": true,
                "multi_sort": [{
                  "sort_by": "publications",
                  "desc": true
                }]
              }
            },
            "props": {
              "api": "/api/v2/dashboard/studio/pr/media/list",
              "dataKey": "prMediaTable",
              "filterLoading": false,
              "trackData": ["frameCode", "prHubGameCode", "prGamesChannels", "extraParams", "studioData"],
              "prPayloadPreset": "pr:studio"
            },
            "children": [{
              "name": "PrMediaTable",
              "className": "margin-t-20",
              "props": {
                "dataKey": "prMediaTable",
                "dataPath": "metrics_list",
                "totalRecordPath": "row_count",
                "metricsCardWrapProps": {
                  "titleEn": "Media Breakdown",
                  "titleCn": "媒体分布",
                  "operation": [{
                    "name": "PrChannelColorLegend",
                    "props": {
                      "variant": "inline",
                      "listDataKey": "prMediaTable"
                    }
                  }, {
                    "name": "PrDownloadButton",
                    "className": "dbd-common-table__operation-btn",
                    "props": {
                      "fileNameEn": "Media Breakdown",
                      "fileNameCn": "媒体分布",
                      "prDownloadTab": "media",
                      "prTableColumns": [{
                        "code": "media",
                        "nameEn": "Media",
                        "nameCn": "媒体数"
                      }, {
                        "code": "country_en",
                        "nameEn": "Country",
                        "nameCn": "国家"
                      }, {
                        "code": "audience",
                        "nameEn": "Audience",
                        "nameCn": "受众规模"
                      }, {
                        "code": "followers",
                        "nameEn": "Followers",
                        "nameCn": "粉丝数"
                      }, {
                        "code": "publications",
                        "nameEn": "Publications",
                        "nameCn": "发帖数"
                      }, {
                        "code": "engagement",
                        "nameEn": "Engagement",
                        "nameCn": "互动量"
                      }]
                    }
                  }]
                },
                "commonBaseTableProps": {
                  "style": {
                    "background": "#fff"
                  },
                  "tableConfig": {
                    "useVirtual": {
                      "horizontal": false,
                      "vertical": false,
                      "header": false
                    },
                    "hidePaginationWhenSinglePage": false,
                    "pagination": {
                      "backendPaging": true
                    }
                  },
                  "columns": [{
                    "code": "row_index",
                    "nameEn": "#",
                    "nameCn": "#",
                    "align": "center",
                    "width": 40,
                    "features": {
                      "sortable": false
                    }
                  }, {
                    "code": "media",
                    "nameEn": "Media",
                    "nameCn": "媒体数",
                    "align": "left",
                    "width": 220,
                    "features": {
                      "sortable": true
                    }
                  }, {
                    "code": "audience",
                    "nameEn": "Audience",
                    "nameCn": "受众规模",
                    "align": "right",
                    "width": 128,
                    "features": {
                      "format": "intBmk0",
                      "downLoadFormat": "#,##0",
                      "sortable": true
                    }
                  }, {
                    "code": "followers",
                    "nameEn": "Followers",
                    "nameCn": "粉丝数",
                    "align": "right",
                    "width": 128,
                    "features": {
                      "format": "intBmk0",
                      "downLoadFormat": "#,##0",
                      "sortable": true
                    }
                  }, {
                    "code": "publications",
                    "nameEn": "Publications",
                    "nameCn": "发帖数",
                    "align": "right",
                    "width": 128,
                    "features": {
                      "format": "intBmk0",
                      "downLoadFormat": "#,##0",
                      "sortable": true
                    }
                  }, {
                    "code": "engagement",
                    "nameEn": "Engagement",
                    "nameCn": "互动量",
                    "align": "right",
                    "width": 128,
                    "features": {
                      "format": "intBmk0",
                      "downLoadFormat": "#,##0",
                      "sortable": true
                    }
                  }]
                }
              }
            }]
          }]
        }, {
          "name": "PrTabPanel",
          "props": {
            "tabId": "regions"
          },
          "children": [{
            "name": "PrStudioService",
            "className": "",
            "type": "view",
            "style": {},
            "data": {
              "extraParams": {
                "page": 1,
                "page_size": 10,
                "sort_by": "publications",
                "desc": true,
                "multi_sort": [{
                  "sort_by": "publications",
                  "desc": true
                }]
              }
            },
            "props": {
              "api": "/api/v2/dashboard/studio/pr/regions/list",
              "dataKey": "prRegionsTable",
              "filterLoading": false,
              "trackData": ["frameCode", "prHubGameCode", "prGamesChannels", "extraParams", "studioData"],
              "prPayloadPreset": "pr:studio"
            },
            "children": [{
              "name": "PrMediaTable",
              "className": "margin-t-20",
              "props": {
                "mode": "regions",
                "dataKey": "prRegionsTable",
                "dataPath": "metrics_list",
                "totalRecordPath": "row_count",
                "metricsCardWrapProps": {
                  "titleEn": "Regions",
                  "titleCn": "地区",
                  "operation": [{
                    "name": "PrChannelColorLegend",
                    "props": {
                      "variant": "inline",
                      "listDataKey": "prRegionsTable"
                    }
                  }, {
                    "name": "PrDownloadButton",
                    "className": "dbd-common-table__operation-btn",
                    "props": {
                      "fileNameEn": "Regions",
                      "fileNameCn": "地区",
                      "prDownloadTab": "regions",
                      "prTableColumns": [{
                        "code": "region_en",
                        "nameEn": "Region",
                        "nameCn": "地区"
                      }, {
                        "code": "creators",
                        "nameEn": "Creators",
                        "nameCn": "创作者"
                      }, {
                        "code": "publications",
                        "nameEn": "Publications",
                        "nameCn": "发帖数"
                      }, {
                        "code": "engagement",
                        "nameEn": "Engagement",
                        "nameCn": "互动量"
                      }, {
                        "code": "views",
                        "nameEn": "Views",
                        "nameCn": "观看量"
                      }, {
                        "code": "hours_watched",
                        "nameEn": "Hours Watched",
                        "nameCn": "观看时长"
                      }]
                    }
                  }]
                },
                "commonBaseTableProps": {
                  "style": {
                    "background": "#fff"
                  },
                  "tableConfig": {
                    "useVirtual": {
                      "horizontal": false,
                      "vertical": false,
                      "header": false
                    },
                    "hidePaginationWhenSinglePage": false,
                    "pagination": {
                      "backendPaging": true
                    }
                  },
                  "columns": [{
                    "nameEn": "Region",
                    "nameCn": "地区",
                    "code": "region",
                    "align": "left",
                    "width": 120,
                    "features": {
                      "sortable": true
                    }
                  }, {
                    "nameEn": "Creators",
                    "nameCn": "创作者",
                    "code": "creators",
                    "align": "right",
                    "width": 120,
                    "features": {
                      "format": "intBmk0",
                      "downLoadFormat": "#,##0",
                      "sortable": true
                    }
                  }, {
                    "nameEn": "Publications",
                    "nameCn": "发帖数",
                    "code": "publications",
                    "align": "right",
                    "width": 120,
                    "features": {
                      "format": "intBmk0",
                      "downLoadFormat": "#,##0",
                      "sortable": true
                    }
                  }, {
                    "nameEn": "Engagement",
                    "nameCn": "互动量",
                    "code": "engagement",
                    "align": "right",
                    "width": 120,
                    "features": {
                      "format": "intBmk0",
                      "downLoadFormat": "#,##0",
                      "sortable": true
                    }
                  }, {
                    "nameEn": "Views",
                    "nameCn": "观看量",
                    "code": "views",
                    "align": "right",
                    "width": 120,
                    "features": {
                      "format": "intBmk0",
                      "downLoadFormat": "#,##0",
                      "sortable": true
                    }
                  }, {
                    "nameEn": "Hours Watched",
                    "nameCn": "观看时长",
                    "code": "hours_watched",
                    "align": "right",
                    "width": 120,
                    "features": {
                      "format": "intBmk0",
                      "downLoadFormat": "#,##0",
                      "sortable": true
                    }
                  }]
                }
              }
            }]
          }]
        }, {
          "name": "PrTabPanel",
          "props": {
            "tabId": "articles"
          },
          "children": [{
            "name": "PrStudioService",
            "className": "",
            "type": "view",
            "style": {},
            "data": {
              "extraParams": {
                "page": 1,
                "page_size": 10,
                "sort_by": "date",
                "desc": true,
                "multi_sort": [{
                  "sort_by": "date",
                  "desc": true
                }]
              }
            },
            "props": {
              "api": "/api/v2/dashboard/studio/pr/articles/list",
              "dataKey": "prArticlesTable",
              "filterLoading": false,
              "trackData": ["frameCode", "prHubGameCode", "prGamesChannels", "extraParams", "studioData"],
              "prPayloadPreset": "pr:studio"
            },
            "children": [{
              "name": "PrMediaTable",
              "className": "margin-t-20",
              "props": {
                "mode": "articles",
                "showSearch": true,
                "dataKey": "prArticlesTable",
                "dataPath": "metrics_list",
                "totalRecordPath": "row_count",
                "metricsCardWrapProps": {
                  "titleEn": "Top Online Articles Coverage",
                  "titleCn": "热门文章覆盖",
                  "operation": [{
                    "name": "PrDownloadButton",
                    "className": "dbd-common-table__operation-btn",
                    "props": {
                      "fileNameEn": "Top Online Articles Coverage",
                      "fileNameCn": "热门文章覆盖",
                      "prDownloadTab": "articles",
                      "prTableColumns": [{
                        "code": "creator",
                        "nameEn": "Creator",
                        "nameCn": "Creator"
                      }, {
                        "code": "country_en",
                        "nameEn": "Region",
                        "nameCn": "地区"
                      }, {
                        "code": "title",
                        "nameEn": "title",
                        "nameCn": "标题"
                      }, {
                        "code": "url",
                        "nameEn": "URL",
                        "nameCn": "链接"
                      }, {
                        "code": "date",
                        "nameEn": "Date",
                        "nameCn": "Date"
                      }]
                    }
                  }]
                },
                "commonBaseTableProps": {
                  "style": {
                    "background": "#fff"
                  },
                  "tableConfig": {
                    "useVirtual": {
                      "horizontal": false,
                      "vertical": false,
                      "header": false
                    },
                    "hidePaginationWhenSinglePage": false,
                    "pagination": {
                      "backendPaging": true
                    }
                  },
                  "columns": [{
                    "code": "row_index",
                    "nameEn": "#",
                    "nameCn": "#",
                    "align": "center",
                    "width": 40,
                    "features": {
                      "sortable": false
                    }
                  }, {
                    "code": "article_date",
                    "nameEn": "Sort by Date",
                    "nameCn": "按日期排序",
                    "align": "left",
                    "width": 680,
                    "features": {
                      "sortable": true
                    }
                  }]
                }
              }
            }]
          }]
        }, {
          "name": "PrTabPanel",
          "props": {
            "tabId": "posts"
          },
          "children": [{
            "name": "PrStudioService",
            "className": "",
            "type": "view",
            "style": {},
            "data": {
              "extraParams": {
                "page": 1,
                "page_size": 10,
                "sort_by": "engagement",
                "desc": true,
                "multi_sort": [{
                  "sort_by": "engagement",
                  "desc": true
                }]
              }
            },
            "props": {
              "api": "/api/v2/dashboard/studio/pr/posts/list",
              "dataKey": "prPostsTable",
              "filterLoading": false,
              "trackData": ["frameCode", "prHubGameCode", "prGamesChannels", "extraParams", "studioData"],
              "prPayloadPreset": "pr:studio"
            },
            "children": [{
              "name": "PrMediaTable",
              "className": "margin-t-20",
              "props": {
                "mode": "posts",
                "showSearch": true,
                "dataKey": "prPostsTable",
                "dataPath": "metrics_list",
                "totalRecordPath": "row_count",
                "metricsCardWrapProps": {
                  "titleEn": "Posts List",
                  "titleCn": "社媒主贴列表",
                  "operation": [{
                    "name": "PrDownloadButton",
                    "className": "dbd-common-table__operation-btn",
                    "props": {
                      "fileNameEn": "Posts List",
                      "fileNameCn": "社媒主贴列表",
                      "prDownloadTab": "posts",
                      "prTableColumns": [{
                        "code": "creator",
                        "nameEn": "Creator",
                        "nameCn": "创作者"
                      }, {
                        "code": "creator_url",
                        "nameEn": "Creator URL",
                        "nameCn": "创作者链接"
                      }, {
                        "code": "country_en",
                        "nameEn": "Region",
                        "nameCn": "地区"
                      }, {
                        "code": "message",
                        "nameEn": "Content",
                        "nameCn": "内容"
                      }, {
                        "code": "channel_url",
                        "nameEn": "Channel URL",
                        "nameCn": "渠道链接"
                      }, {
                        "code": "channel",
                        "nameEn": "Channel",
                        "nameCn": "渠道"
                      }, {
                        "code": "post_time",
                        "nameEn": "Post Time",
                        "nameCn": "Post Time"
                      }, {
                        "code": "engagement",
                        "nameEn": "Engagement",
                        "nameCn": "互动量"
                      }, {
                        "code": "likes",
                        "nameEn": "Likes",
                        "nameCn": "点赞"
                      }, {
                        "code": "comments",
                        "nameEn": "Comments",
                        "nameCn": "评论"
                      }]
                    }
                  }]
                },
                "commonBaseTableProps": {
                  "style": {
                    "background": "#fff"
                  },
                  "tableConfig": {
                    "useVirtual": {
                      "horizontal": false,
                      "vertical": false,
                      "header": false
                    },
                    "hidePaginationWhenSinglePage": false,
                    "pagination": {
                      "backendPaging": true
                    }
                  },
                  "columns": [{
                    "code": "row_index",
                    "nameEn": "#",
                    "nameCn": "#",
                    "align": "center",
                    "width": 40,
                    "features": {
                      "sortable": false
                    }
                  }, {
                    "code": "article_date",
                    "nameEn": "Sort by Date",
                    "nameCn": "按日期排序",
                    "align": "left",
                    "width": 640,
                    "features": {
                      "sortable": true
                    }
                  }, {
                    "code": "engagement",
                    "nameEn": "Engagement",
                    "nameCn": "互动量",
                    "align": "right",
                    "width": 120,
                    "features": {
                      "format": "intBmk0",
                      "downLoadFormat": "#,##0",
                      "sortable": true
                    }
                  }]
                }
              }
            }]
          }]
        }, {
          "name": "PrTabPanel",
          "props": {
            "tabId": "videos"
          },
          "children": [{
            "name": "PrStudioService",
            "className": "",
            "type": "view",
            "style": {},
            "data": {
              "extraParams": {
                "page": 1,
                "page_size": 10,
                "sort_by": "engagement",
                "desc": true,
                "multi_sort": [{
                  "sort_by": "engagement",
                  "desc": true
                }]
              }
            },
            "props": {
              "api": "/api/v2/dashboard/studio/pr/videos/list",
              "dataKey": "prVideosTable",
              "filterLoading": false,
              "trackData": ["frameCode", "prHubGameCode", "prGamesChannels", "extraParams", "studioData"],
              "prPayloadPreset": "pr:studio"
            },
            "children": [{
              "name": "PrMediaTable",
              "className": "margin-t-20",
              "props": {
                "mode": "videos",
                "showSearch": true,
                "dataKey": "prVideosTable",
                "dataPath": "metrics_list",
                "totalRecordPath": "row_count",
                "metricsCardWrapProps": {
                  "titleEn": "Most Viewed Videos",
                  "titleCn": "最多观看视频",
                  "operation": [{
                    "name": "PrDownloadButton",
                    "className": "dbd-common-table__operation-btn",
                    "props": {
                      "fileNameEn": "Most Viewed Videos",
                      "fileNameCn": "最多观看视频",
                      "prDownloadTab": "videos",
                      "prTableColumns": [{
                        "code": "creator",
                        "nameEn": "Creator",
                        "nameCn": "Creator"
                      }, {
                        "code": "country_en",
                        "nameEn": "Region",
                        "nameCn": "地区"
                      }, {
                        "code": "video_title",
                        "nameEn": "Video Title",
                        "nameCn": "视频标题"
                      }, {
                        "code": "url",
                        "nameEn": "URL",
                        "nameCn": "链接"
                      }, {
                        "code": "channel",
                        "nameEn": "Channel",
                        "nameCn": "渠道"
                      }, {
                        "code": "date",
                        "nameEn": "Date",
                        "nameCn": "Date"
                      }, {
                        "code": "engagement",
                        "nameEn": "Engagement",
                        "nameCn": "互动量"
                      }, {
                        "code": "likes",
                        "nameEn": "Likes",
                        "nameCn": "点赞"
                      }, {
                        "code": "comments",
                        "nameEn": "Comments",
                        "nameCn": "评论"
                      }]
                    }
                  }]
                },
                "commonBaseTableProps": {
                  "style": {
                    "background": "#fff"
                  },
                  "tableConfig": {
                    "useVirtual": {
                      "horizontal": false,
                      "vertical": false,
                      "header": false
                    },
                    "hidePaginationWhenSinglePage": false,
                    "pagination": {
                      "backendPaging": true
                    }
                  },
                  "columns": [{
                    "code": "row_index",
                    "nameEn": "#",
                    "nameCn": "#",
                    "align": "center",
                    "width": 40,
                    "features": {
                      "sortable": false
                    }
                  }, {
                    "code": "article_date",
                    "nameEn": "Sort by Date",
                    "nameCn": "按日期排序",
                    "align": "left",
                    "width": 640,
                    "features": {
                      "sortable": true
                    }
                  }, {
                    "code": "engagement",
                    "nameEn": "Engagement",
                    "nameCn": "互动量",
                    "align": "right",
                    "width": 120,
                    "features": {
                      "format": "intBmk0",
                      "downLoadFormat": "#,##0",
                      "sortable": true
                    }
                  }]
                }
              }
            }]
          }]
        }, {
          "name": "PrTabPanel",
          "props": {
            "tabId": "streams"
          },
          "children": [{
            "name": "PrStudioService",
            "className": "",
            "type": "view",
            "style": {},
            "data": {
              "extraParams": {
                "page": 1,
                "page_size": 10,
                "sort_by": "max_cc_viewers",
                "desc": true,
                "multi_sort": [{
                  "sort_by": "max_cc_viewers",
                  "desc": true
                }]
              }
            },
            "props": {
              "api": "/api/v2/dashboard/studio/pr/streams/list",
              "dataKey": "prStreamsTable",
              "filterLoading": false,
              "trackData": ["frameCode", "prHubGameCode", "prGamesChannels", "extraParams", "studioData"],
              "prPayloadPreset": "pr:studio"
            },
            "children": [{
              "name": "PrMediaTable",
              "className": "margin-t-20",
              "props": {
                "mode": "streams",
                "showSearch": true,
                "cardLinkEnabled": true,
                "dataKey": "prStreamsTable",
                "dataPath": "metrics_list",
                "totalRecordPath": "row_count",
                "metricsCardWrapProps": {
                  "titleEn": "Most Viewed Streams",
                  "titleCn": "最多观看直播",
                  "operation": [{
                    "name": "PrDownloadButton",
                    "className": "dbd-common-table__operation-btn",
                    "props": {
                      "fileNameEn": "Most Viewed Streams",
                      "fileNameCn": "最多观看直播",
                      "prDownloadTab": "streams",
                      "prTableColumns": [{
                        "code": "creator",
                        "nameEn": "Creator",
                        "nameCn": "Creator"
                      }, {
                        "code": "creator_url",
                        "nameEn": "Creator URL",
                        "nameCn": "创作者链接"
                      }, {
                        "code": "country_en",
                        "nameEn": "Region",
                        "nameCn": "地区"
                      }, {
                        "code": "title",
                        "nameEn": "Title",
                        "nameCn": "标题"
                      }, {
                        "code": "channel_url",
                        "nameEn": "Channel URL",
                        "nameCn": "渠道链接"
                      }, {
                        "code": "channel",
                        "nameEn": "Channel",
                        "nameCn": "渠道"
                      }, {
                        "code": "stream_time",
                        "nameEn": "Stream Time",
                        "nameCn": "Stream Time"
                      }, {
                        "code": "avg_cc_viewers",
                        "nameEn": "Avg CC Viewers",
                        "nameCn": "平均同时在线观众数"
                      }, {
                        "code": "max_cc_viewers",
                        "nameEn": "Max CC Viewers",
                        "nameCn": "峰值同时在线观众数"
                      }, {
                        "code": "hours_watched",
                        "nameEn": "Hours Watched",
                        "nameCn": "观看时长"
                      }]
                    }
                  }]
                },
                "commonBaseTableProps": {
                  "style": {
                    "background": "#fff"
                  },
                  "tableConfig": {
                    "useVirtual": {
                      "horizontal": false,
                      "vertical": false,
                      "header": false
                    },
                    "hidePaginationWhenSinglePage": false,
                    "pagination": {
                      "backendPaging": true
                    }
                  },
                  "columns": [{
                    "code": "row_index",
                    "nameEn": "#",
                    "nameCn": "#",
                    "align": "center",
                    "width": 40,
                    "features": {
                      "sortable": false
                    }
                  }, {
                    "code": "date",
                    "nameEn": "Sort by Date",
                    "nameCn": "按日期排序",
                    "align": "left",
                    "width": 560,
                    "features": {
                      "sortable": true
                    }
                  }, {
                    "code": "avg_cc_viewers",
                    "nameEn": "Avg CC Viewers",
                    "nameCn": "平均同时在线观众数",
                    "align": "right",
                    "width": 130,
                    "features": {
                      "format": "intBmk0",
                      "downLoadFormat": "#,##0",
                      "sortable": true
                    }
                  }, {
                    "code": "max_cc_viewers",
                    "nameEn": "Max CC Viewers",
                    "nameCn": "峰值同时在线观众数",
                    "align": "right",
                    "width": 150,
                    "features": {
                      "format": "intBmk0",
                      "downLoadFormat": "#,##0",
                      "sortable": true
                    }
                  }, {
                    "code": "hours_watched",
                    "nameEn": "Hours Watched",
                    "nameCn": "观看时长",
                    "align": "right",
                    "width": 130,
                    "features": {
                      "format": "intBmk0",
                      "downLoadFormat": "#,##0",
                      "sortable": true
                    }
                  }]
                }
              }
            }]
          }]
        }]
    }]
  }]
};